import { HlsPlayer } from './HlsPlayer';
import { Events, FragBufferedData } from 'hls.js';

export class BufferGapStallDetector {
	constructor(
		private hlsPlayer: HlsPlayer
	) {
		this.init();
	}

	private init(): void {
		this.hlsPlayer.player.on(this.hlsPlayer.HlsEvents.FRAG_BUFFERED, this.onFragBuffered);
	}

	public destroy(): void {
		this.hlsPlayer.player.off(this.hlsPlayer.HlsEvents.FRAG_BUFFERED, this.onFragBuffered);
	}

	private onFragBuffered = (_event, { frag }: FragBufferedData) => {
		const { currentTime } = this.hlsPlayer;
		const buffer = [];
		const buffered = this.hlsPlayer.videoElement.buffered;
		const fragEnd: number = frag.start + frag.duration;
		const isCurrentTimeWithinFrag: boolean = currentTime >= frag.start && currentTime <= fragEnd;

		if (buffered.length && isCurrentTimeWithinFrag && !this.getIsCurrentTimeBuffered(currentTime)) {
			console.warn(`BufferGapStallDetector - stall detected @ ${currentTime}, so nudging ahead`);

			for (let x = 0, len = buffered.length; x < len; ++x) {
				buffer.push([
					buffered.start(x),
					buffered.end(x)
				].join('-'));
			}
			console.warn('BufferGapStallDetector -', buffer.join(', '));

			const deltaPTS = (frag as any).deltaPTS || 0;

			this.hlsPlayer.videoElement.currentTime = currentTime + deltaPTS + 0.01;
		}
	};

	private getIsCurrentTimeBuffered(currentTime: number): boolean {
		const buffered: TimeRanges = this.hlsPlayer.videoElement.buffered;

		for (let x = 0, len = buffered.length; x < len; ++x) {
			if (currentTime >= buffered.start(x) && currentTime <= buffered.end(x)) {
				return true;
			}
		}

		return false;
	}
}
